import React, { useState } from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, Divider, Typography, Paper } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LockIcon from '@mui/icons-material/Lock';
import { useTheme } from '../ThemeContext';
import MyProfile from './MyProfile';
import Subscription from './Subscription';
import ChangePassword from './ChangePassword';

const Settings = () => {
  const { mode, toggleTheme } = useTheme();
  const [activeTab, setActiveTab] = useState('profile');

  const menuItems = [
    { id: 'profile', label: 'My Profile', icon: <PersonIcon />, component: <MyProfile /> },
    { id: 'subscription', label: 'Subscription', icon: <CreditCardIcon />, component: <Subscription /> },
    { id: 'password', label: 'Change Password', icon: <LockIcon />, component: <ChangePassword /> },
  ];
  
  return (
    <Box sx={{ display: 'flex', gap: 3, width: '100%', m: 0, p: 0 }}>
      {/* Left Navigation */}
      <Paper sx={{ width: 250, flexShrink: 0, m: 0 }}>
        <List>
          {menuItems.map((item) => (
            <React.Fragment key={item.id}>
              <ListItem
                button
                selected={activeTab === item.id}
                onClick={() => setActiveTab(item.id)}
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: 'primary.light',
                    '&:hover': {
                      backgroundColor: 'primary.light',
                    },
                  },
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItem>
              <Divider />
            </React.Fragment>
          ))}
        </List>
      </Paper>

      {/* Content Area */}
      <Paper sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h5" gutterBottom>
          {menuItems.find(item => item.id === activeTab)?.label}
        </Typography>
        {menuItems.find(item => item.id === activeTab)?.component}
      </Paper>
    </Box>
  );
};

export default Settings;